module.exports = __webpack_public_path__ + "img/trash_filled_24.9d7c80cb.svg";